// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.width360[data-v-7db90a9e] {\n  width: 360px;\n}\n.width200[data-v-7db90a9e]{\n  width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
